export const blockIconsMapsLocalHospitalNew = (
	<span className='material-symbols-outlined'>local_hospital</span>
);
